import { render } from "./uiFormSelect.vue?vue&type=template&id=06953aa2"
import script from "./uiFormSelect.vue?vue&type=script&lang=js"
export * from "./uiFormSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__